var Image = require("enyo/Image"),
    kind  = require("enyo/kind");

require("enyo/Image/Image.css");
require("app/ui/Image.less");

module.exports = kind(/** @lends  app.ui.Image.prototype */ {

    /**
     * @private
     */
    name: "app.ui.Image",

    /**
     * @private
     */
    kind: Image,

    /**
     * @private
     */
    classes: "app-ui-image",

    /**
     * @public
     */
    placeholder: "data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",

    /**
     * @private
     */
    handlers: {
        onmousedown: "onMouseDown"
    },

    /**
     * Prevent default behavior on dragstart, this prevents firefox from
     * dragging images.
     *
     * @param  {enyo.Control}  sender  The sender of the event
     * @param  {Object}        event   The event object.
     * @public
     */
    onDragStart: function(sender, event) {
        if (this.getAttribute("draggable") === "false") {
            event.preventDefault();
        }
    },

    /**
     * Prevent default behavior on mousedown, this prevents firefox from
     * dragging images.
     *
     * @param  {enyo.Control}  sender  The sender of the event
     * @param  {Object}        event   The event object.
     * @public
     */
    onMouseDown: function(sender, event) {
        if (this.getAttribute("draggable") === "false") {
            event.preventDefault();
        }
    }

});
